import { createContext } from 'react';
import { EnterpriseProfile, EnterpriseUser } from 'src/api/enterprise-profile/types';

export interface EnterpriseProfileContextState {
  profile: EnterpriseProfile;
  profileImageUpdated: () => void;
  profileUserImageUpdated: () => void;
  profileBannerUpdated: () => void;
  update: (func: (p: EnterpriseProfile) => EnterpriseProfile) => void;
  updateCurrentUser: () => void;
  reload: () => void;
  /** Recarga solo la completitud servida por la API (issue #1774), sin repetir la consulta del layout. */
  refreshCompletion: () => void;
  emailVerified?: boolean;
  isAdmin?: boolean;
  currentUser?: EnterpriseUser;
  enterpriseAdmin?: EnterpriseUser;
}

const EnterpriseProfileContext = createContext<EnterpriseProfileContextState>({
  profile: undefined as any,
  profileImageUpdated: () => {},
  profileUserImageUpdated: () => {},
  profileBannerUpdated: () => {},
  update: () => {},
  updateCurrentUser: () => {},
  reload: () => {},
  refreshCompletion: () => {}
});
export default EnterpriseProfileContext;
